import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { User } from '../../../user-management/users/user';
import { UsersService } from '../../../user-management/users/users.service';
import * as userInformationActions from '../actions';

@Injectable()
export class UserInformationEffect {
  @Effect()
  public loadUserInformation$ = this.actions$.pipe(
    ofType<userInformationActions.LoadUserInformation>(
      userInformationActions.LOAD_USER_INFORMATION
    ),
    switchMap(() =>
      this.usersService.getUser().pipe(
        map(
          (user: User) =>
            new userInformationActions.LoadUserInformationSuccess(user)
        ),
        catchError((error: any) =>
          of(new userInformationActions.LoadUserInformationFail(error))
        )
      )
    )
  );

  constructor(private actions$: Actions, private usersService: UsersService) {}
}
